import { dataFetcher } from 'core/services/requestHandler';   

const getNotificationList = async (data = {}, config = {}) => {
  return dataFetcher('notifications', data, {...config});
};

const deleteNotificationById = async (data = {}, config = {}, path='') => {
  return dataFetcher(`notifications/delete/${path}`, data, {...config});
};

export { getNotificationList, deleteNotificationById };
